import { applyTTSPrefs } from './ttsUtils';
import { buzz } from './vibrate';

// Opt-in accessibility: when a reminder/alarm fires, optionally vibrate the
// phone and/or read the event title aloud. The two are INDEPENDENT toggles in
// the Accessibility dropdown: 'memo_a11y_vibrate' and 'memo_a11y_speak'.
// (Legacy 'memo_a11y_reminders' = both, kept for back-compat.)
//
// Honest limits: vibration works on Android (Chrome); iOS Safari does not
// support the Vibration API (there the alarm sound + push still fire). Both this
// and the spoken read-out only run while the app is OPEN (the in-app scheduler
// doesn't run in the background — that's what push notifications are for).
export function announceReminderA11y(event, opts = {}) {
  if (!event) return;
  let vibrate = false, speak = false;
  try {
    const legacy = localStorage.getItem('memo_a11y_reminders') === '1';
    vibrate = legacy || localStorage.getItem('memo_a11y_vibrate') === '1';
    speak   = legacy || localStorage.getItem('memo_a11y_speak') === '1';
  } catch (_) {}

  // Vibrate (Android): a distinct long alarm-like pattern.
  if (vibrate) { try { buzz([500, 200, 500, 200, 500]); } catch (_) {} }

  // Speak the event title, using the user's saved TTS voice/pitch/speed.
  if (speak) {
    try {
      if (!window.speechSynthesis) return;
      const utt = new SpeechSynthesisUtterance(String(event.title || ''));
      if (opts.speechLang) utt.lang = opts.speechLang;
      applyTTSPrefs(utt);
      window.speechSynthesis.cancel(); // don't stack utterances
      window.speechSynthesis.speak(utt);
    } catch (_) {}
  }
}
